// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper___67kmX","label":"styles-module__label___lqyuM","button":"styles-module__button___lzXMY"};